import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderService } from "ngx-ui-loader";
import printJS from 'print-js-updated';
import { AppCoreService } from "src/app/services/app-core.service";
import { AWBService } from "src/app/services/operations/awb.service";


@Component({
    selector: 'app-label-print',
    templateUrl: './label-print.component.html',
    styleUrls: ['./label-print.component.scss'],
})

export class LabelPrintComponent implements OnInit {
    labelForm: FormGroup;
    isFormSubmitted = false;
    differenceInValue = 100;
    isGreaterDifference = false;
    @Input() public awbNumber: number;
    @Input() public totalPieceNo: number;

    constructor(
        private formBuilder: FormBuilder,
        public activeModal: NgbActiveModal,
        private appCoreService: AppCoreService,
        private ngxLoaderService: NgxUiLoaderService,
        private awbService: AWBService
    ) { }
    ngOnInit(): void {
        this.labelForm = this.formBuilder.group({
            txtFromNo: ['', Validators.compose([Validators.required])],
            txtToNo: [''],
        });

        this.bindForm();
    }

    bindForm() {
        this.labelForm.patchValue({
            txtFromNo: 1,
            txtToNo: this.totalPieceNo
        });
    }

    validateRange() {
        const fromNo = parseInt(this.labelForm.get('txtFromNo')?.value);
        const toNo = parseInt(this.labelForm.get('txtToNo')?.value);
        const maxValue = fromNo + this.differenceInValue;

        if (isNaN(fromNo) || isNaN(toNo)) {
            this.appCoreService.showMessage('Please enter valid numbers.', 'Error', 'error');
            this.isGreaterDifference = true;
            return;
        }

        if (toNo > maxValue) {
            this.appCoreService.showMessage('Maximum value exceeded.', 'Info', 'info');
        } else if (toNo < fromNo) {
            this.appCoreService.showMessage('Value of To is smaller than From.', 'Info', 'info');
        } else {
            this.isGreaterDifference = false;
            return;
        }
        this.isGreaterDifference = true;
    }

    // onSaveClick() {
    //     if (this.isGreaterDifference) {
    //         this.validateRange();
    //         return;
    //     }

    //     if (this.labelForm.invalid) {
    //         return;
    //     }

    //     try {

    //         let inputParams = {
    //             awbNumber: this.awbNumber,
    //             printType: 'label',
    //             details:{
    //                 from:this.labelForm.get('txtFromNo')?.value,
    //                 to:this.labelForm.get('txtToNo')?.value
    //             }
    //         }
    //         this.ngxLoaderService.start();
    //         this.awbService.GeneratePDF(inputParams).subscribe((res) => {
    //             if (res && res.success) {
    //                 this.ngxLoaderService.stop();
    //                 this.activeModal.close('Pdf is generated');
    //                 const pdfString = res.data;
    //                 printJS({ printable: pdfString, type: 'pdf', base64: true, showModal: true });
    //             }
    //         })
    //     } catch (err) {
    //         this.ngxLoaderService.stop();
    //     }
    // }

    onSaveClick() {
        if (this.isGreaterDifference) {
            this.validateRange();
            return;
        }

        if (this.labelForm.invalid) {
            return;
        }

        try {
            // Prepare the input parameters for PDF generation
            const inputParams = {
                awbNumber: this.awbNumber,
                printType: 'label',
                details: {
                    from: this.labelForm.get('txtFromNo')?.value,
                    to: this.labelForm.get('txtToNo')?.value
                }
            };

            this.ngxLoaderService.start();

            this.awbService.GeneratePDF(inputParams).subscribe(
                (res) => {
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        this.activeModal.close('Pdf is generated');

                        const pdfString = res.data[0];

                        if (this.isMobile()) {
                            this.printPDFMobile(pdfString);
                        } else {
                            // For desktop, use printJS for printing
                            printJS({ printable: pdfString, type: 'pdf', base64: true, showModal: true });
                        }
                    }
                },
                (error) => {
                    this.ngxLoaderService.stop();
                    console.error('PDF Generation Error:', error);
                }
            );
        } catch (err) {
            this.ngxLoaderService.stop();
            console.error('Unexpected Error:', err);
        }
    }

    isMobile(): boolean {
        return /Mobi|Android/i.test(navigator.userAgent);
    }

    printPDFMobile(pdfString: string): void {
        console.log("mobile pringing");

        const printWindow = window.open('', '', 'width=600,height=800');

        if (!printWindow) {
            console.error('Failed to open print window');
            return;
        }

        // Write the PDF data into the print window
        printWindow.document.write('<html><head><title>Print</title></head><body>');
        printWindow.document.write('<embed id="pdfEmbed" width="100%" height="100%" src="data:application/pdf;base64,' + pdfString + '" type="application/pdf">');
        printWindow.document.write('</body></html>');

        // Ensure the document is fully loaded before triggering the print dialog
        printWindow.document.close();

        // Get the embed element
        const embedElement = printWindow.document.getElementById('pdfEmbed') as HTMLEmbedElement;

        embedElement.onerror = () => {
            console.error('Failed to load PDF for printing');
            printWindow.close();
        };
    }

    resetForm() {
        this.labelForm.reset();
        this.isFormSubmitted = false;
    }
}